import {
	experienceManifestId,
	type ExperienceManifestId,
} from '@atlassian/native-embeds-core/types/experience/types';

/**
 * Stable identifier for the Artifacts native-embed experience.
 *
 * Exposed via the dedicated `./manifest-id` subpath so lightweight consumers
 * (e.g. test helpers, registries) can import just the id without pulling in the
 * full manifest module through the package barrel.
 */
export const ARTIFACTS_EXPERIENCE_MANIFEST_ID: ExperienceManifestId =
	experienceManifestId('artifacts');
